import type { Route } from "@legacy/models/Route";

export const extractDirectionsFromRoute = (route: Route | undefined) => ({
    firstDirection: `${route?.originLocationMachineName}-to-${route?.destinationLocationMachineName}`,
    secondDirection: `${route?.destinationLocationMachineName}-to-${route?.originLocationMachineName}`,
});
